import request from '@/util/request';

/**
 * 获取操作日志列表
 * @param {Object} params - 查询参数
 * @returns {Promise} 查询请求Promise
 */
export const getTOperationLogList = (params) => {
    return request.get('/tOperationLog/list', { params });
};

/**
 * 导出操作日志Excel
 * @param {Array|null} logIds - 选中的日志ID数组，为null时导出全部
 * @returns {Promise} 导出请求Promise
 */
export const getTOperationLogExcel = (logIds = null) => {
    return request.post('/tOperationLog/exportExcel', logIds, {
        responseType: 'blob', // 设置响应类型为blob以处理文件下载
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 记录跳转后台信息
export const recordJumpBackstageInfo = () => {
    return request.get('/tOperationLog/goToBackstage');
};